import { jsx as _jsx } from "react/jsx-runtime";
import UIButton from 'UIComponents/button/UIButton';
import { PlaylistAssignmentsTablePage, usePlaylistAssignmentsPortals } from '..';
import { FormattedMessage } from '../../../components/I18n';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import PlaylistAssignmentsPortalsTable from './PlaylistAssignmentsPortalsTable';

const PlaylistAssignmentsPortalsCount = ({
  playlistId
}) => {
  const {
    total
  } = usePlaylistAssignmentsPortals({
    playlistId
  });
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `learningCenter.playlistAssignments.portalsCount`,
    options: {
      count: total
    }
  });
};

const PlaylistAssignmentsPortals = ({
  playlistId
}) => {
  return /*#__PURE__*/_jsx(PlaylistAssignmentsTablePage, {
    actions: /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.assignPlaylist"
      })
    }),
    enabledFilters: [FILTER_TYPES.SEARCH_TEAMS],
    headerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistAssignments.portalsHeader"
    }),
    tableCount: /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsCount, {
      playlistId: playlistId
    }),
    children: /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTable, {
      playlistId: playlistId
    })
  });
};

export default PlaylistAssignmentsPortals;